export default class Logger {
  static log(...params) {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.log(...params);
    }
  }
}
